module.exports = {"140424100":"麟绛镇","140424101":"上村镇","140424102":"渔泽镇","140424103":"余吾镇","140424104":"吾元镇","140424105":"张店镇","140424106":"丰宜镇","140424200":"李高乡","140424201":"路村乡","140424202":"河神庙乡","140424203":"西贾乡","140424400":"西流寨开发区","140424401":"康庄工业园区","140424402":"上莲开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140424.json
// module id = 298
// module chunks = 0